import { styled } from '@mui/material/styles';
import { ComplianceDocument, MarketingAssetSchema } from '@/lib/types';

type BadgeColor = 'red' | 'blue' | 'grey';

const FileTypeBadge = ({
  extension,
  file,
}: {
  extension?: string;
  file?: ComplianceDocument | MarketingAssetSchema;
}) => {
  if (!extension) return null;

  const isCompliance = !!file && 'document_type' in file;
  const isMarketing = !!file && 'file_type' in file;

  const color: BadgeColor = isCompliance
    ? 'red'
    : isMarketing
      ? 'blue'
      : 'grey';

  return (
    <BadgeRoot $color={color}>{extension.toUpperCase()}</BadgeRoot>
  );
};

const BadgeRoot = styled('div')<{ $color: BadgeColor }>(
  ({ theme, $color }) => ({
    boxSizing: 'border-box',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 44,
    height: 20,
    padding: '0 6px',
    borderRadius: theme.radii.md,
    fontSize: '10px',
    fontWeight: 600,
    lineHeight: 1,
    whiteSpace: 'nowrap',
    ...($color === 'red'
      ? {
          backgroundColor: theme.palette.red50,
          border: `2px solid ${theme.palette.red400}`,
          color: theme.palette.red400,
        }
      : $color === 'blue'
        ? {
            backgroundColor: theme.palette.blue50,
            border: `2px solid ${theme.palette.blue500}`,
            color: theme.palette.blue500,
          }
        : {
            backgroundColor: theme.palette.grey50,
            border: `2px solid ${theme.palette.grey400}`,
            color: theme.palette.grey500,
          }),
  }),
);

export default FileTypeBadge;
